import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'components/core/Image';
import greenArrow from 'assets/images/icons/green-arrow.svg';
import { H3, Paragraph, Text } from 'components/core/Typography';

import './AverageUnitPriceHeader.scss';

/**
 *
 * @param {*} averagePriceData
 * @returns priceHistory: {date: price}, averagePrice, totalReservations
 *
 * @param {*} city
 * @returns city (string) from Page leve
 */
const AverageUnitPriceHeader = ({ averagePriceData = null, city = '', state }) => {
	const [todaysPrice, yesterdayPrice] = useMemo(() => {
		if (
			!averagePriceData.priceHistory[
				averagePriceData.priceHistory.length - 1
			]?.price
		)
			return [];

		return [
			averagePriceData.priceHistory[
				averagePriceData.priceHistory.length - 1
			]?.price,
			averagePriceData.priceHistory[
				averagePriceData.priceHistory.length - 2
			]?.price,
		];
	}, [averagePriceData.priceHistory]);

	const [priceDifference, isPriceLower] = useMemo(() => {
		if (!todaysPrice || !yesterdayPrice) return [];

		return [todaysPrice - yesterdayPrice, todaysPrice < yesterdayPrice];
	}, [todaysPrice, yesterdayPrice]);

	return (
		<>
			<div className="average-price-header-container">
				<div className="left-side-text">
					<H3 className="sf-type-medium">
						{`Average Monthly Price by Storage Unit Size in ${city}, ${state}`}
					</H3>
					<Paragraph
						className="sf-type-small sf-type-weight-standard price-history-text"
						color="gray"
					>
						Based on {averagePriceData.totalReservations} storage
						units in {city}.
					</Paragraph>
				</div>

				<div className="right-side-text">
					<Paragraph
						className="sf-type-xlarge"
						weight="bold"
					>
						${todaysPrice?.toFixed(2)}
						{/* Ensure a fixed number of decimal places */}
					</Paragraph>

					<span className="divider" />

					<div className="right-text-column">
						<div className="difference-row">
							<Image
								src={greenArrow}
								className={
									isPriceLower
										? 'price-is-lower-arrow'
										: 'price-is-higher-arrow'
								}
								alt={'ReducedTo'}
								width="14"
								height="16"
							/>

							<Text className="sf-type-small up-or-down-text">
								{isPriceLower ? 'Down' : 'Up'}
							</Text>
							<Text className="sf-type-small">
								${Math.abs(priceDifference?.toFixed(2))}
							</Text>
						</div>

						<Text
							className="sf-type-smaller sf-type-weight-standard"
							color="gray"
						>
							Compared to last month
						</Text>
					</div>
				</div>
			</div>
		</>
	);
};

AverageUnitPriceHeader.propTypes = {
	averagePriceData: PropTypes.shape({
		priceHistory: PropTypes.array,
		totalReservations: PropTypes.number,
		averagePrice: PropTypes.number,
	}),
	city: PropTypes.string,
};

export default AverageUnitPriceHeader;
